import { AfterContentInit, ChangeDetectorRef, Component, ElementRef, Input, ViewChild } from '@angular/core';
import * as calcite from 'calcite-web';
import { UtilsService } from '../../services/utils.service';
import { DrawToolComponent } from '../draw-tool/draw-tool.component';

@Component({
    selector: 'app-tools',
    templateUrl: './tools.component.html',
    styleUrls: ['./tools.component.css']
})
export class ToolsComponent implements AfterContentInit {

    @ViewChild('area') private areaRef: ElementRef<any>;
    @ViewChild('drawTool') private drawTool: DrawToolComponent;
    @ViewChild('distance') private distanceRef: ElementRef<any>;
    @ViewChild('coordinates') private coordinatesRef: ElementRef<any>;
    @ViewChild('calloutTool') private calloutTool: ElementRef<any>;
    @ViewChild('calloutToolWindow') private calloutToolWindow: ElementRef<any>;
    @ViewChild('drawToolWindow', { static: true }) private drawToolWindow: ElementRef<any>;
    @ViewChild('measureToolsWindow') private measureToolsWindow: ElementRef<any>;
    @ViewChild('petl', { static: true }) private petl: ElementRef<any>;
    @ViewChild('petlWindow', { static: true }) private petlWindow: ElementRef<any>;
    @ViewChild('streetView') private streetView: ElementRef<any>;
    @ViewChild('streetViewWindow', { static: true }) private streetViewWindow: ElementRef<any>;
    @ViewChild('videoLogWindow') private videoLogWindow: ElementRef<any>;
    @ViewChild('tabs') private tabsRef: ElementRef<any>;

    @Input() visible: boolean;
    streetViewInitialized: boolean;
    videoLogInitialized: boolean;

    constructor(
        private changeDetectorRef: ChangeDetectorRef,
        private utilsService: UtilsService,
    ) { }

    ngAfterContentInit() {
        calcite.dropdown();
        this.closeToolsOnClick();
        this.drawToolWindow.nativeElement.addEventListener('openChange', open => {
            open.detail ? this.drawTool.open() : this.drawTool.close();
            this.utilsService.activateIdentify(!open.detail);
        });
        this.utilsService.streetViewWindow = this.streetViewWindow;
        this.utilsService.streetView = this.streetView;

        this.petlWindow.nativeElement.addEventListener('openChange', open => {
            this.petl.nativeElement.active = open.detail;
            if (open.detail) {
                this.petl.nativeElement.initialize();
            }
        });

        this.utilsService.streetViewWindow = this.streetViewWindow;
    }

    get tooltipsTextOnOrOff(): string {
        const tooltipEnabled = this.utilsService.tooltip && this.utilsService.tooltip.nativeElement.tooltipEnabled;
        return tooltipEnabled ? 'Off' : 'On';
    }

    closePetl(e: MouseEvent) {
        e.preventDefault();
        this.petlWindow.nativeElement.close();
    }

    closeToolsOnClick() {
        const body = document.getElementsByTagName('body')[0];
        body.addEventListener('click', (e: any) => {
            const pathClases = e.composedPath().map(x => x.className);
            if (pathClases.indexOf('btn tools') < 0) {
                this.visible = false;
            }
        });
    }

    onDrawToolWindowOpenChange(e) {
        if (!e.detail) {
            this.drawTool.close();
        }
    }

    onCalloutBoxWindowOpenChange(e) {
        if (!e.detail) {
            (<any>this.calloutTool).nativeElement.active = false;
            this.utilsService.identify.nativeElement.activate();
        }
    }

    onMeasureToolWindowOpenChange(e) {
        if (!e.detail) {
            this.areaRef.nativeElement.active = false;
            this.distanceRef.nativeElement.active = false;
            this.utilsService.identify.nativeElement.activate();
        }
    }

    onMeasureToolsTabChanged(e) {
        const refs = {
            'Area': this.areaRef,
            'Coordinates': this.coordinatesRef,
            'Distance': this.distanceRef
        };
        for (const ref of Object.keys(refs)) {
            refs[ref].nativeElement.active = ref === e.detail.name;
        }
    }

    onStreetViewWindowOpenChange(e) {
        if (!e.detail) {
            (<any>this.streetViewWindow).nativeElement.active = false;
            (<any>this.streetView).nativeElement.active = false;
            (<any>this.streetView).nativeElement.lat = null;
            (<any>this.streetView).nativeElement.long = null;
        }
    }

    onVideoLogWindowOpenChange(e) {
        if (!e.detail) {
            (<any>this.videoLogWindow).nativeElement.active = false;
        }
    }

    openDrawTool() {
        this.drawToolWindow.nativeElement.open();
    }

    openCalloutBox() {
        this.utilsService.identify.nativeElement.deactivate();
        this.calloutToolWindow.nativeElement.open();
        (<any>this.calloutTool).nativeElement.active = true;
    }

    openMeasureTools() {
        this.utilsService.identify.nativeElement.deactivate();
        this.measureToolsWindow.nativeElement.open();
        this.tabsRef.nativeElement.activateTab('Distance');
        this.distanceRef.nativeElement.active = true;
    }

    openPetl(e: MouseEvent) {
        e.preventDefault();
        this.petlWindow.nativeElement.open();
    }

    openStreetView() {
        this.utilsService.openStreetView();
    }

    openVideoLog() {
        if (!this.videoLogInitialized) {
            const videoLog: any = document.getElementById('videoLog');
            this.utilsService.videoLogWindow = this.videoLogWindow;
            this.videoLogWindow.nativeElement.addEventListener('openChange', e => {
                videoLog.active = e.detail;
            });
            this.videoLogInitialized = true;
        }
        this.videoLogWindow.nativeElement.open();
    }

    toggleTooltips() {
        this.utilsService.tooltip.nativeElement.tooltipEnabled = !this.utilsService.tooltip.nativeElement.tooltipEnabled;
    }

}
